import React from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import { GetWithdrawalMethodResponse } from '../../../Api/CRM/Responses/WithdrawalMethodResponse';
import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import ViewButton from '../../elements/ViewButton';
import BooleanIcon from '../../elements/booleanIcon';
import Card from '../../elements/common/Card';
import { TableCell as Cell } from '../../elements/common/TableDetailsRow';
import TableHead from '../../elements/common/TableHead';
import TableLoader from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import { PERMISSION } from '../../helpers/Permissions';
import useAutoPaginator from '../../hooks/useAutoPaginator';

function WithdrawalMethodsList() {
    const { items, updateItems, isLoading, auto } = useAutoPaginator<GetWithdrawalMethodResponse>(
        async (page, params) => (await CRMApi.get(`withdrawal_method?page=${page}`, { params })).data
    );

    const withdrawalMethodsList = items.map((method) => (
        <tr key={method.id}>
            <td>
                <ViewButton url={`/withdrawal_methods/${method.id}`} permissions={[PERMISSION.VIEW_WITHDRAWAL_METHOD]} />
                <EditButton url={`/withdrawal_methods/${method.id}/edit`} permissions={[PERMISSION.UPDATE_WITHDRAWAL_METHOD]} />
                <DeleteButton
                    url={`/crea/api/withdrawal_method/${method.id}`}
                    action={updateItems}
                    permissions={[PERMISSION.DELETE_WITHDRAWAL_METHOD]}
                />
            </td>
            <Cell>{method.name}</Cell>
            <Cell>{method.slug}</Cell>
            <Cell>{method.transaction_currency}</Cell>
            <Cell>{`${method.user_fixed_fee} ${method.user_fixed_fee_currency}`}</Cell>
            <Cell>{method.user_percent_fee}</Cell>
            <td>
                <BooleanIcon value={method.is_web} />
            </td>
            <td>
                <BooleanIcon value={method.is_mobile} />
            </td>
            <td>
                <BooleanIcon value={!method.is_disabled} />
            </td>
        </tr>
    ));

    return (
        <>
            <ActionButton
                title="Create new withdrawal method"
                url="/withdrawal_methods/create"
                permissions={[PERMISSION.CREATE_WITHDRAWAL_METHOD]}
            />
            <Card title="Withdrawal Methods">
                <TableLoader isLoading={isLoading}>
                    <table className="table">
                        <TableHead>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Slug</th>
                            <th>Currency</th>
                            <th>User fixed Fee</th>
                            <th>User percent fee</th>
                            <th>Is web?</th>
                            <th>Is mobile?</th>
                            <th>Is enabled?</th>
                        </TableHead>
                        <tbody>{withdrawalMethodsList}</tbody>
                    </table>
                    <Paginator {...auto.paginator} />
                </TableLoader>
            </Card>
        </>
    );
}

export default WithdrawalMethodsList;
